import { FC, useEffect, useState } from 'react';

import cn from 'classnames';

import s from './ShellTaskbar.module.scss';
import {
  ShellTrayChatIcon,
  ShellTrayMouseIcon,
  ShellTrayNetworkIcon,
  ShellTraySoundIcon,
  ShellTrayTaskManagerIcon,
} from './ShellTrayIcons';

interface IShellTaskbarProps {
  className?: string;
}

type TKeyboardLayout = 'ENG' | 'РУС';

const formatTime = (date: Date): string =>
  date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

const formatDate = (date: Date): string =>
  date.toLocaleDateString([], {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

export const ShellTaskbar: FC<IShellTaskbarProps> = ({ className }) => {
  const [now, setNow] = useState(() => new Date());
  const [keyboardLayout, setKeyboardLayout] = useState<TKeyboardLayout>('ENG');

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 1000);

    return () => window.clearInterval(timer);
  }, []);

  const toggleKeyboardLayout = (): void => {
    setKeyboardLayout((value) => (value === 'ENG' ? 'РУС' : 'ENG'));
  };

  return (
    <footer
      className={cn(s.ssShellTaskbar, className)}
      aria-label="Панель задач"
    >
      <div className={s.ssShellTaskbarTray}>
        <button
          className={cn(s.ssShellTaskbarIconButton, s.ssShellTaskbarLanguage)}
          type="button"
          aria-label="Сменить раскладку клавиатуры"
          onClick={toggleKeyboardLayout}
        >
          {keyboardLayout}
        </button>
        <button
          className={s.ssShellTaskbarIconButton}
          type="button"
          aria-label="Мышь"
        >
          <ShellTrayMouseIcon className={s.ssShellTaskbarMouseIcon} />
        </button>
        <button
          className={s.ssShellTaskbarIconButton}
          type="button"
          aria-label="Громкость"
        >
          <ShellTraySoundIcon className={s.ssShellTaskbarSoundIcon} />
        </button>
        <button
          className={s.ssShellTaskbarIconButton}
          type="button"
          aria-label="Чат"
        >
          <ShellTrayChatIcon className={s.ssShellTaskbarChatIcon} />
        </button>
        <button
          className={s.ssShellTaskbarIconButton}
          type="button"
          aria-label="Диспетчер задач"
        >
          <ShellTrayTaskManagerIcon
            className={s.ssShellTaskbarTaskManagerIcon}
          />
        </button>
        <button
          className={s.ssShellTaskbarIconButton}
          type="button"
          aria-label="Сеть"
        >
          <ShellTrayNetworkIcon className={s.ssShellTaskbarNetworkIcon} />
        </button>
        <time className={s.ssShellTaskbarDateTime} dateTime={now.toISOString()}>
          <span>{formatTime(now)}</span>
          <span>{formatDate(now)}</span>
        </time>
      </div>
    </footer>
  );
};
